<template>
  <div class="flex flex-col h-full" v-loading="loading">
    <el-card v-if="isShowBackButton" class="m-5">
      <template #header>
        <div class="flex justify-between items-center">
          <span class="text-lg font-bold">{{ $t('mo_detail') }}</span>
          <div>
            <el-button @click="goBack">
              <span class="mr-2">←</span>
              {{ $t('back') }}
            </el-button>
          </div>
        </div>
      </template>
      <div v-if="mo" class="flex flex-col">
        <ManufacturingOrderTable :mo="mo" />

        <span class="font-medium h-11 my-4px flex items-center">{{ $t('component_item') }}</span>
        <div class="mb-10 flex-grow">
          <div class="table-wrapper">
            <el-table
              class="rounded-xl w-full"
              ref="tableUsePlansRef"
              :data="mo.usePlans || []"
              header-cell-class-name="custom-table__header-cell"
              cell-class-name="custom-table__cell "
              border
              :empty-text="$t('empty')"
              max-height="380px"
            >
              <el-table-column
                v-for="col in componentItemColumns"
                :key="col.prop"
                :prop="col.prop"
                :label="col.label"
                :min-width="20"
              >
                <template v-slot="scope">
                  <span v-if="col.formatter">{{ col.formatter(scope.row) }}</span>
                  <span v-else>{{ getNestedValue(scope.row, col.prop) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
    <div v-else>
      <div v-if="mo" class="flex flex-col">
        <ManufacturingOrderTable :mo="mo" table-class="mb-6" />

        <!-- <span class="font-medium h-11 my-4px flex items-center">{{ $t('component_item') }}</span>
        <div class="mb-6 flex-grow">
          <div class="table-wrapper">
            <el-table
              class="rounded-xl w-full"
              ref="tableUsePlansRef"
              :data="mo.usePlans || []"
              header-cell-class-name="custom-table__header-cell"
              cell-class-name="custom-table__cell "
              border
              :empty-text="$t('empty')"
              max-height="380px"
            >
              <el-table-column
                v-for="col in componentItemColumns"
                :key="col.prop"
                :prop="col.prop"
                :label="col.label"
                :min-width="20"
              >
                <template v-slot="scope">
                  <span v-if="col.formatter">{{ col.formatter(scope.row) }}</span>
                  <span v-else>{{ getNestedValue(scope.row, col.prop) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ManufacturingOrderTable from '@/components/mo/ManufacturingOrderTable.vue'
import { FETCH_MANUFACTURING_ORDER_DETAIL } from '@/store/actions'
import { formatQuantityWithUnit } from '@/utils/helpers'
import { getNestedValue } from '@/utils/tableUtils'
import { IManufacturingPlan, IUsePlan } from '@/utils/types/model/manufacturingPlan'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

interface IComponentItemColumn {
  prop: string
  label: string
  formatter?: (row: IUsePlan) => string
}

@Options({
  name: 'ManufacturingPlanDetail',
  components: {
    ManufacturingOrderTable,
  },
})
export default class ManufacturingPlanDetail extends Vue {
  @Prop({ type: String, default: '' }) id!: string
  @Prop({ type: Boolean, default: true }) isShowBackButton!: boolean

  get moID(): string {
    return this.id || (this.$route.params.id as string)
  }

  get mo(): IManufacturingPlan | null {
    return this.$store.getters.getManufacturingOrderDetail || null
  }

  get loading(): boolean {
    return this.$store.getters.isMOLoading || false
  }

  get componentItemColumns(): IComponentItemColumn[] {
    return [
      { prop: 'itemCode', label: this.$t('component_item_code') as string },
      { prop: 'itemName', label: this.$t('component_item_name') as string },
      {
        prop: 'plannedUsageQuantity',
        label: this.$t('planned_usage_quantity') as string,
        formatter: (row: IUsePlan) => formatQuantityWithUnit(row.plannedUsageQuantity, row.stockUnit),
      },
    ]
  }

  getNestedValue(obj: Record<string, unknown>, path: string): unknown {
    return getNestedValue(obj, path)
  }

  getInstructionNo(): string {
    const dateStr = this.mo?.manufactureCompletionDate
    if (!dateStr) return ''
    const formatted = dateStr.slice(0, 10).replace(/-/g, '')
    return `ORNO${this.mo?.orderType}${this.mo?.orderNumber}${this.mo?.projectCode}${this.mo?.companyCode}${formatted}`
  }

  goBack() {
    this.$router.back()
  }

  created() {
    this.$store.dispatch(FETCH_MANUFACTURING_ORDER_DETAIL, this.moID)
  }
}
</script>

<style lang="scss" scoped>
.card-header {
  padding: 1.25rem;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
  margin-bottom: 1.25rem;
}

.card-body {
  padding: 0 1.25rem 1.25rem;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-wrapper:deep() {
  min-width: 800px;
}

.table-actions {
  padding: 1.25rem 0;
}

.full-page-width {
  width: 100%;
}
</style>
